import * as Joi from 'joi';
import { numberFormatConfigSchema } from '../../chart-client-state/types/v2';
import { AnswerColumnPropVersion, } from '../../types/prism';
class AnswerColumnPropV1Class {
}
const AnswerColumnPropV1Schema = Joi.object({
    __typename: Joi.string().valid('AnswerColumnProps'),
    version: Joi.string()
        .valid(AnswerColumnPropVersion.V1)
        .required(),
    columnProperties: Joi.object({
        __typename: Joi.string().valid('AnswerColumnProperty'),
        format: numberFormatConfigSchema.allow(null),
        sortConfig: Joi.string().allow(null),
    }).allow(null),
});
export { AnswerColumnPropV1Class, AnswerColumnPropV1Schema };
//# sourceMappingURL=v1.js.map